import {Component, Input, TemplateRef} from '@angular/core';
import {EnvironmentService} from '../../services/environment-service';

@Component({
  selector: 'greydom-broker-menu',
  templateUrl: './broker-menu.component.html',
  styleUrls: ['./broker-menu.component.scss']
})
export class BrokerMenuComponent {

  @Input() template: TemplateRef<any>;
  @Input() logoAndSettingsIcon: TemplateRef<any>;
  @Input() supportIconTpl: TemplateRef<any>;
  @Input() accountAndLogoutIconTpl: TemplateRef<any>;

  externalUrl: string;

  constructor(private environmentService: EnvironmentService) {
    this.externalUrl = this.environmentService.getExternalClientUrl();
  }

  onClickBackTohHome(): void {
    window.open(this.externalUrl, '_blank');
  }
}
